import { enableProdMode } from '@angular/core';

import { platformBrowser } from '@angular/platform-browser';

import {
  AppBrowserModule,
  preserveAgrSessionSnapshot,
  setupRuntimeConfig,
} from './app/app.browser.module';
import { environment } from './environments/environment';

if (environment.PRODUCTION) {
  enableProdMode();
}
preserveAgrSessionSnapshot();
setupRuntimeConfig.then(() => {
  platformBrowser()
    .bootstrapModule(AppBrowserModule)
    .catch((err) => console.error(err));
});
